"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagramComponent2 = void 0;
const react_1 = __importDefault(require("react"));
const react_svg_1 = require("react-svg");
function DiagramComponent2(props) {
    function adjustDiagramSize(svg) {
        svg.setAttribute('width', '100%');
        svg.setAttribute('height', '100%');
    }
    function adjustForegroundGroups(svg) {
        if (props.hideForegroundDrawing) {
            const parentElement = svg.getElementById(props.fileName);
            const childrenElements = parentElement.children;
            for (let i = 0; i < childrenElements.length; i++) {
                const element = childrenElements[i];
                const elementId = element.id;
                if (elementId === 'bg') {
                    continue;
                }
                element.setAttribute('style', 'opacity:0.01');
            }
        }
    }
    function adjustZoomIn(svg) {
        var _a, _b, _c, _d;
        const wholeBBox = svg.getBBox();
        const availableWidth = parseInt(`${(_d = (_c = (_b = (_a = svg.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().width) !== null && _d !== void 0 ? _d : 0}`);
        const isMobile = availableWidth <= 500;
        if (props.zoomInScale <= 0 || props.zoomInScale === 1) {
            return;
        }
        const parentElement = svg.getElementById(props.fileName);
        const childrenElements = parentElement.children;
        for (let i = 0; i < childrenElements.length; i++) {
            const element = childrenElements[i];
            const elementId = element.id;
            if (elementId === 'bg') {
                continue;
            }
            if (elementId === props.targetDetectionId) {
                const elementBBox = convertCoordinates(element, svg);
                const centerX = elementBBox.x + elementBBox.width / 2 + props.offsetX;
                const centerY = elementBBox.y + elementBBox.height / 2 + props.offsetY;
                let zoomInScale = props.zoomInScale;
                if (isMobile) {
                    if (Math.max(elementBBox.width, elementBBox.height) <= 50) {
                        zoomInScale = 3;
                    }
                    else if (Math.max(elementBBox.width, elementBBox.height) <= 100) {
                        zoomInScale = 2;
                    }
                }
                const scaleWidth = wholeBBox.width / zoomInScale;
                const scaleHeight = wholeBBox.height / zoomInScale;
                const newX = centerX - scaleWidth / 2;
                const newY = centerY - scaleHeight / 2;
                svg.setAttribute('viewBox', `${newX} ${newY} ${scaleWidth} ${scaleHeight}`);
            }
        }
        return;
    }
    function adjustStyles(svg) {
        // svg.setAttribute(
        //   'class',
        //   'drop-shadow-[0_4px_18px_rgba(103, 58, 183,1)]'
        // );
        // svg.setAttribute('class', 'drop-shadow-[0_4px_18px_rgba(103,58,183,1)]');
        const parentElement = svg.getElementById(props.fileName);
        const childrenElements = parentElement.children;
        for (let i = 0; i < childrenElements.length; i++) {
            const element = childrenElements[i];
            const elementId = element.id;
            if (elementId === 'bg') {
                continue;
            }
            // if (props.highlightIds.length === 0) {
            //   element.setAttribute('class', 'hover:fill-black hover:sacle-125');
            // }
        }
    }
    function handleHighlight(svg) {
        if (props.highlightIds.length === 0) {
            return;
        }
        const parentElement = svg.getElementById(props.fileName);
        const childrenElements = parentElement.children;
        for (let i = 0; i < childrenElements.length; i++) {
            const element = childrenElements[i];
            const elementId = element.id;
            if (elementId === 'bg') {
                continue;
            }
            if (props.highlightIds.includes(elementId)) {
                element.setAttribute('style', 'opacity:1');
                // element.setAttribute(
                //   'class',
                //   'drop-shadow-[0_6px_6px_rgba(0,0,0,0.20)] drop-shadow-[0_10px_14px_rgba(0,0,0,0.14)] drop-shadow-[0_4px_18px_rgba(103,58,183,1)]'
                // );
                // element.setAttribute(
                //   'class',
                //   'drop-shadow-[0_4px_18px_rgba(103,58,183,1)]'
                // );
                // element.classList.add('pulse');
                // svg.classList.add('pulse');
            }
            else {
                if (props.hideForegroundDrawing) {
                    element.setAttribute('style', 'opacity:0.01');
                }
                else {
                    element.setAttribute('style', 'opacity:0.3');
                }
            }
        }
    }
    function handleClick(e) {
        const clickedPointX = e.clientX;
        const clickedPointY = e.clientY;
        const parentElement = document.getElementById(props.fileName);
        if (!parentElement) {
            return;
        }
        const childrenElements = parentElement.children;
        const clickedElements = [];
        for (let i = 0; i < childrenElements.length; i++) {
            const element = childrenElements[i];
            const elementId = element.id;
            const rect = element.getBoundingClientRect();
            if (isPointInBounds(rect, clickedPointX, clickedPointY)) {
                if (elementId !== props.fileName) {
                    clickedElements.push(element);
                }
            }
        }
        if (clickedElements.length > 0) {
            const map = new Map();
            for (const element of clickedElements) {
                if (element.id === 'bg') {
                    continue;
                }
                let counter = 0;
                const rect = element.getBoundingClientRect();
                const points = generateDetectionPoints(clickedPointX, clickedPointY);
                for (const point of points) {
                    if (isPointInBounds(rect, point[0], point[1])) {
                        counter += 1;
                    }
                }
                map.set(element.id, counter);
            }
            let selectedId = undefined;
            const sum = Object.values(map).reduce((acc, value) => acc + value, 0);
            if (map.has(props.targetDetectionId) &&
                map.get(props.targetDetectionId) >= sum / 2) {
                selectedId = props.targetDetectionId;
            }
            else {
                let maxCounter = 0;
                map.forEach((counter, elementId) => {
                    if (counter > maxCounter) {
                        maxCounter = counter;
                        selectedId = elementId;
                    }
                });
            }
            if (!selectedId) {
                selectedId = 'bg';
            }
            if (selectedId && props.onSelect) {
                props.onSelect(selectedId);
            }
        }
    }
    function convertCoordinates(element, containerSVG) {
        const bbox = element.getBBox();
        const matrix = element.getCTM();
        let topLeft = containerSVG.createSVGPoint();
        let bottomRight = containerSVG.createSVGPoint();
        topLeft.x = bbox.x;
        topLeft.y = bbox.y;
        bottomRight.x = bbox.x + bbox.width;
        bottomRight.y = bbox.y + bbox.height;
        topLeft = topLeft.matrixTransform(matrix);
        bottomRight = bottomRight.matrixTransform(matrix);
        return {
            x: topLeft.x,
            y: topLeft.y,
            width: bottomRight.x - topLeft.x,
            height: bottomRight.y - topLeft.y,
        };
    }
    function generateDetectionPoints(x, y) {
        function convertTupleToString(tuple) {
            return JSON.stringify(tuple);
        }
        function convertStringToTuple(str) {
            return JSON.parse(str);
        }
        const delta = 0.2;
        const radius = 3; // in pixel
        const count = radius / delta;
        const points = new Set();
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                const pointX = x + i * delta;
                const pointY = y + j * delta;
                points.add(convertTupleToString([pointX, pointY]));
            }
        }
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                const pointX = x - i * delta;
                const pointY = y - j * delta;
                points.add(convertTupleToString([pointX, pointY]));
            }
        }
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                const pointX = x + i * delta;
                const pointY = y - j * delta;
                points.add(convertTupleToString([pointX, pointY]));
            }
        }
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                const pointX = x - i * delta;
                const pointY = y + j * delta;
                points.add(convertTupleToString([pointX, pointY]));
            }
        }
        return Array.from(points).map(str => convertStringToTuple(str));
    }
    function isPointInBounds(bound, x, y) {
        return (x >= bound.left && x <= bound.right && y >= bound.top && y <= bound.bottom);
    }
    // function isPointInDrawing(
    //   element: SVGSVGElement,
    //   x: number,
    //   y: number
    // ): boolean {
    //   const pt = element.createSVGPoint();
    //   pt.x = x;
    //   pt.y = y;
    //   const svgPoint = pt.matrixTransform(element.getScreenCTM()?.inverse());
    //   const elementAtPoint = document.elementFromPoint(svgPoint.x, svgPoint.y);
    //   return element.contains(elementAtPoint);
    // }
    return (react_1.default.createElement(react_svg_1.ReactSVG, { wrapper: "svg", className: "w-full h-full", evalScripts: "always", afterInjection: svg => {
            adjustDiagramSize(svg);
            adjustZoomIn(svg);
            adjustStyles(svg);
            adjustForegroundGroups(svg);
            handleHighlight(svg);
        }, fallback: () => (react_1.default.createElement("div", { className: "flex w-full h-full items-center justify-center" }, "Unable to load this svg file!")), httpRequestWithCredentials: false, loading: () => (react_1.default.createElement("div", { className: "flex w-full h-full items-center justify-center" }, "Loading")), onClick: e => {
            handleClick(e);
        }, onError: error => {
            console.error(error);
        }, src: props.src, title: props.title, desc: props.description }));
}
exports.DiagramComponent2 = DiagramComponent2;
// export const DiagramComponent2 = forwardRef<SVGElement, DiagramComponentProps2>(
//   (props, ref) => {
//     function adjustDiagramSize(svg: SVGSVGElement) {
//       svg.setAttribute(
//         'width',
//         `${svg.parentElement?.parentElement?.parentElement?.getBoundingClientRect().width}`
//       );
//       svg.setAttribute(
//         'height',
//         `${svg.parentElement?.parentElement?.parentElement?.getBoundingClientRect().height}`
//       );
//     }
//     function adjustForegroundGroups(svg: SVGSVGElement) {
//       if (props.hideForegroundDrawing) {
//         const parentElement = svg.getElementById(props.fileName);
//         const childrenElements = parentElement.children;
//         for (let i = 0; i < childrenElements.length; i++) {
//           const element = childrenElements[i];
//           const elementId = element.id;
//           if (elementId === 'bg') {
//             continue;
//           }
//           element.setAttribute('style', 'opacity:0.01');
//         }
//       }
//     }
//     function adjustZoomIn(svg: SVGSVGElement) {
//       const wholeBBox = svg.getBBox();
//       const availableWidth = parseInt(
//         `${svg.parentElement?.parentElement?.parentElement?.getBoundingClientRect().width}`
//       );
//       const isMobile = availableWidth <= 500;
//       if (props.zoomInScale <= 0 || props.zoomInScale === 1) {
//         return;
//       }
//       const parentElement = svg.getElementById(props.fileName);
//       const childrenElements = parentElement.children;
//       for (let i = 0; i < childrenElements.length; i++) {
//         const element = childrenElements[i];
//         const elementId = element.id;
//         if (elementId === 'bg') {
//           continue;
//         }
//         if (elementId === props.targetDetectionId) {
//           const elementBBox = convertCoordinates(
//             element as SVGGraphicsElement,
//             svg
//           );
//           const centerX = elementBBox.x + elementBBox.width / 2 + props.offsetX;
//           const centerY =
//             elementBBox.y + elementBBox.height / 2 + props.offsetY;
//           let zoomInScale = props.zoomInScale;
//           if (isMobile) {
//             if (Math.max(elementBBox.width, elementBBox.height) <= 50) {
//               zoomInScale = 3;
//             } else if (Math.max(elementBBox.width, elementBBox.height) <= 100) {
//               zoomInScale = 2;
//             }
//           }
//           const scaleWidth = wholeBBox.width / zoomInScale;
//           const scaleHeight = wholeBBox.height / zoomInScale;
//           const newX = centerX - scaleWidth / 2;
//           const newY = centerY - scaleHeight / 2;
//           svg.setAttribute(
//             'viewBox',
//             `${newX} ${newY} ${scaleWidth} ${scaleHeight}`
//           );
//         }
//       }
//       return;
//     }
//     function adjustStyles(svg: SVGSVGElement) {
//       // svg.setAttribute(
//       //   'class',
//       //   'drop-shadow-[0_4px_18px_rgba(103, 58, 183,1)]'
//       // );
//       // svg.setAttribute('class', 'drop-shadow-[0_4px_18px_rgba(103,58,183,1)]');
//       const parentElement = svg.getElementById(props.fileName);
//       const childrenElements = parentElement.children;
//       for (let i = 0; i < childrenElements.length; i++) {
//         const element = childrenElements[i];
//         const elementId = element.id;
//         if (elementId === 'bg') {
//           continue;
//         }
//         if (props.highlightIds.length === 0) {
//           element.setAttribute('class', 'hover:fill-black hover:sacle-125');
//         }
//       }
//     }
//     function handleHighlight(svg: SVGSVGElement) {
//       if (props.highlightIds.length === 0) {
//         return;
//       }
//       const parentElement = svg.getElementById(props.fileName);
//       const childrenElements = parentElement.children;
//       for (let i = 0; i < childrenElements.length; i++) {
//         const element = childrenElements[i];
//         const elementId = element.id;
//         if (elementId === 'bg') {
//           continue;
//         }
//         if (props.highlightIds.includes(elementId)) {
//           element.setAttribute('style', 'opacity:1');
//           // element.setAttribute(
//           //   'class',
//           //   'drop-shadow-[0_6px_6px_rgba(0,0,0,0.20)] drop-shadow-[0_10px_14px_rgba(0,0,0,0.14)] drop-shadow-[0_4px_18px_rgba(103,58,183,1)]'
//           // );
//           // element.setAttribute(
//           //   'class',
//           //   'drop-shadow-[0_4px_18px_rgba(103,58,183,1)]'
//           // );
//           // element.classList.add('pulse');
//           // svg.classList.add('pulse');
//         } else {
//           if (props.hideForegroundDrawing) {
//             element.setAttribute('style', 'opacity:0.01');
//           } else {
//             element.setAttribute('style', 'opacity:0.3');
//           }
//         }
//       }
//     }
//     function handleClick(e: React.MouseEvent) {
//       const clickedPointX = e.clientX;
//       const clickedPointY = e.clientY;
//       const parentElement = document.getElementById(props.fileName);
//       if (!parentElement) {
//         return;
//       }
//       const childrenElements = parentElement.children;
//       const clickedElements: Element[] = [];
//       for (let i = 0; i < childrenElements.length; i++) {
//         const element = childrenElements[i];
//         const elementId = element.id;
//         const rect = element.getBoundingClientRect();
//         if (isPointInBounds(rect, clickedPointX, clickedPointY)) {
//           if (elementId !== props.fileName) {
//             clickedElements.push(element);
//           }
//         }
//       }
//       if (clickedElements.length > 0) {
//         const map: Map<string, number> = new Map();
//         for (const element of clickedElements) {
//           if (element.id === 'bg') {
//             continue;
//           }
//           let counter = 0;
//           const rect = element.getBoundingClientRect();
//           const points = generateDetectionPoints(clickedPointX, clickedPointY);
//           for (const point of points) {
//             if (isPointInBounds(rect, point[0], point[1])) {
//               counter += 1;
//             }
//           }
//           map.set(element.id, counter);
//         }
//         let selectedId: string | undefined = undefined;
//         const sum = Object.values(map).reduce(
//           (acc: number, value: number) => acc + value,
//           0
//         ) as number;
//         if (
//           map.has(props.targetDetectionId) &&
//           map.get(props.targetDetectionId)! >= sum / 2
//         ) {
//           selectedId = props.targetDetectionId;
//         } else {
//           let maxCounter = 0;
//           map.forEach((counter, elementId) => {
//             if (counter > maxCounter) {
//               maxCounter = counter;
//               selectedId = elementId;
//             }
//           });
//         }
//         if (!selectedId) {
//           selectedId = 'bg';
//         }
//         if (selectedId && props.onSelect) {
//           props.onSelect(selectedId);
//         }
//       }
//     }
//     function convertCoordinates(
//       element: SVGGraphicsElement,
//       containerSVG: SVGSVGElement
//     ) {
//       const bbox = element.getBBox();
//       const matrix = element.getCTM();
//       let topLeft = containerSVG.createSVGPoint();
//       let bottomRight = containerSVG.createSVGPoint();
//       topLeft.x = bbox.x;
//       topLeft.y = bbox.y;
//       bottomRight.x = bbox.x + bbox.width;
//       bottomRight.y = bbox.y + bbox.height;
//       topLeft = topLeft.matrixTransform(matrix!);
//       bottomRight = bottomRight.matrixTransform(matrix!);
//       return {
//         x: topLeft.x,
//         y: topLeft.y,
//         width: bottomRight.x - topLeft.x,
//         height: bottomRight.y - topLeft.y,
//       };
//     }
//     function generateDetectionPoints(x: number, y: number): [number, number][] {
//       function convertTupleToString(tuple: [number, number]): string {
//         return JSON.stringify(tuple);
//       }
//       function convertStringToTuple(str: string): [number, number] {
//         return JSON.parse(str);
//       }
//       const delta = 0.2;
//       const radius = 3; // in pixel
//       const count = radius / delta;
//       const points = new Set<string>();
//       for (let i = 0; i < count; i++) {
//         for (let j = 0; j < count; j++) {
//           const pointX = x + i * delta;
//           const pointY = y + j * delta;
//           points.add(convertTupleToString([pointX, pointY]));
//         }
//       }
//       for (let i = 0; i < count; i++) {
//         for (let j = 0; j < count; j++) {
//           const pointX = x - i * delta;
//           const pointY = y - j * delta;
//           points.add(convertTupleToString([pointX, pointY]));
//         }
//       }
//       for (let i = 0; i < count; i++) {
//         for (let j = 0; j < count; j++) {
//           const pointX = x + i * delta;
//           const pointY = y - j * delta;
//           points.add(convertTupleToString([pointX, pointY]));
//         }
//       }
//       for (let i = 0; i < count; i++) {
//         for (let j = 0; j < count; j++) {
//           const pointX = x - i * delta;
//           const pointY = y + j * delta;
//           points.add(convertTupleToString([pointX, pointY]));
//         }
//       }
//       return Array.from(points).map(str => convertStringToTuple(str));
//     }
//     function isPointInBounds(bound: DOMRect, x: number, y: number): boolean {
//       return (
//         x >= bound.left &&
//         x <= bound.right &&
//         y >= bound.top &&
//         y <= bound.bottom
//       );
//     }
//     // function isPointInDrawing(
//     //   element: SVGSVGElement,
//     //   x: number,
//     //   y: number
//     // ): boolean {
//     //   const pt = element.createSVGPoint();
//     //   pt.x = x;
//     //   pt.y = y;
//     //   const svgPoint = pt.matrixTransform(element.getScreenCTM()?.inverse());
//     //   const elementAtPoint = document.elementFromPoint(svgPoint.x, svgPoint.y);
//     //   return element.contains(elementAtPoint);
//     // }
//     return (
//       <ReactSVG
//         evalScripts="always"
//         afterInjection={svg => {
//           adjustDiagramSize(svg);
//           adjustZoomIn(svg);
//           adjustStyles(svg);
//           adjustForegroundGroups(svg);
//           handleHighlight(svg);
//         }}
//         fallback={() => <span>Error!</span>}
//         httpRequestWithCredentials={false}
//         loading={() => <span>Loading</span>}
//         onClick={e => {
//           handleClick(e);
//         }}
//         onError={error => {
//           console.error(error);
//         }}
//         src={props.src}
//         title={props.title}
//         desc={props.description}
//       />
//     );
//   }
// );
